import { object, string } from 'yup';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_15_LENGTH } from '@constants/validationMessages';

export const schema = object({
	nodeId: string()
		.trim()
		.default('')
		.required(validationErrMessages.nodeB)
		.max(MAX_15_LENGTH, getMaxLengthErrMsg('NodeB ID', MAX_15_LENGTH)),
});
